import React, { useContext, useEffect, useRef, useState } from "react";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import { Button, Input, Modal, Space, Table, Tooltip, Typography } from "antd";
import {
    DeleteOutlined,
    EditOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import moment from "jalali-moment";

const FeedBackTable = () => {
    // search
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`جستجو`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        style={{
                            width: 90,
                        }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters);
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{
                            width: 90,
                        }}
                    >
                        حذف فیلتر
                    </Button>

                    <Button
                        type="link"
                        onClick={() => {
                            close();
                        }}
                    >
                        بستن
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => (searchedColumn === dataIndex ? text : text),
    });
    // context
    const {
        forceUpdate,
        setSelectedFeedBackId,
        setForceUpdate,
        selectedFeedBackId,
        setFeedBackData,
        setFeedBackEndDate,
        setFeedBackEndText,
        setFeedBackStartDate,
        setFeedBackStartText,
    } = useContext(context);
    // state
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteModalOpen, setDeleteIsModalOpen] = useState(false);

    // useEffect
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Interaction/Feedback`)
            .then((res) => {
                setLoading(false);
                setTableData(res.data.result);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [forceUpdate]);

    // columns
    const columns = [
        {
            title: "عنوان",
            dataIndex: "title",
            key: "title",
            width: "10%",
            ...getColumnSearchProps("title"),
        },
        {
            title: "تاریخ شروع نظرسنجی",
            dataIndex: "startDate",
            key: "startDate",
            width: "10%",
            render: (_, { startDate }) => (
                <>
                    <Typography.Text>
                        {moment(startDate.slice(0, 10), "YYYY/MM/DD")
                            .locale("fa")
                            .format("YYYY/MM/DD")}
                    </Typography.Text>
                </>
            ),
        },
        {
            title: "تاریخ پایان نظرسنجی",
            dataIndex: "endDate",
            key: "endDate",
            width: "10%",
            render: (_, { endDate }) => (
                <>
                    <Typography.Text>
                        {moment(endDate.slice(0, 10), "YYYY/MM/DD")
                            .locale("fa")
                            .format("YYYY/MM/DD")}
                    </Typography.Text>
                </>
            ),
        },
        {
            title: "تعداد شرکت کنندگان",
            dataIndex: "userId",
            key: "userId",
            width: "10%",
            render: (_, { userId }) => (
                <>
                    <Typography.Text>{userId.length}</Typography.Text>
                </>
            ),
        },
        {
            title: "متن شروع",
            dataIndex: "textStart",
            key: "textStart",
            render: (_, { textStart }) => (
                <Tooltip title={textStart}>
                    <Typography.Text style={{ cursor: "pointer" }}>
                        {textStart.slice(0, 40)}
                        {textStart.length > 40 ? "..." : null}
                    </Typography.Text>
                </Tooltip>
            ),
        },
        {
            title: "متن پایان",
            dataIndex: "textEnd",
            key: "textEnd",
            render: (_, { textEnd }) => (
                <Tooltip title={textEnd}>
                    <Typography.Text style={{ cursor: "pointer" }}>
                        {textEnd.slice(0, 40)}
                        {textEnd.length > 40 ? "..." : null}
                    </Typography.Text>
                </Tooltip>
            ),
        },
        {
            title: "تعداد سوالات",
            dataIndex: "data",
            key: "data",
            width: "10%",
            render: (_, { data }) => (
                <>
                    <Typography.Text>{data.length}</Typography.Text>
                </>
            ),
        },
        {
            title: "عملیات",
            dataIndex: "button",
            key: "button",
            width: "10%",
            render: (text, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Button
                            onClick={() => {
                                setDeleteIsModalOpen(true);
                                setSelectedFeedBackId(record._id);
                            }}
                            type="primary"
                            danger
                            shape="round"
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                        <Tooltip title="ویرایش">
                            <Link to="/editFeedBack">
                                <Button
                                    onClick={() => handleEditFeedBack(record)}
                                    type="primary"
                                    icon={<EditOutlined />}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                />
                            </Link>
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ];

    // functions
    const handleCancelModal = () => {
        setDeleteIsModalOpen(false);
    };
    const handleEditFeedBack = (record) => {
        setSelectedFeedBackId(record._id);
        setFeedBackData(record.data);
        setFeedBackEndDate(record.endDate);
        setFeedBackStartDate(record.startDate);
        setFeedBackEndText(record.textEnd);
        setFeedBackStartText(record.textStart);
    };
    const handleOkModal = () => {
        http.delete(
            `${config.parkopoloApi}/api/Interaction/Feedback/${selectedFeedBackId}`
        )
            .then(() => {
                setForceUpdate(11);
            })
            .catch((err) => {
                console.log(err);
                setForceUpdate(12);
            });
        setDeleteIsModalOpen(false);
        setForceUpdate(150);
    };

    return (
        <>
            <Table
                style={{ marginTop: "15px" }}
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                    showSizeChanger: false,
                }}
                bordered
                columns={columns}
                dataSource={tableData}
                scroll={{ x: true }}
                loading={loading}
                onRow={(record) => {
                    return {
                        onClick: () => setSelectedFeedBackId(record._id),
                    };
                }}
            />
            <Modal
                title="حذف کامل"
                open={deleteModalOpen}
                onOk={handleOkModal}
                onCancel={handleCancelModal}
                okText="حذف"
            >
                <p>مطمئنی میخوای حذف کنی؟</p>
            </Modal>
        </>
    );
};

export default FeedBackTable;
